import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { webhooksQuery } from '../../../../data/webhooks.tsx'
import { WebhookForm } from '../../../../features/serviceManagement/webhooks/WebhookForm.tsx'

const RouteComponent = () => {
	const { webhook } = Route.useLoaderData()
	return <WebhookForm key={webhook.updatedAt} webhook={webhook} />
}

export const Route = createFileRoute('/_app/smp/webhooks/$webhookId/edit')({
	validateSearch: z.object({
		secretId: z.string().optional(),
		invocationId: z.string().optional(),
	}),
	loader: async (ctx) => {
		const webhooks = await ctx.context.queryClient.ensureQueryData(webhooksQuery(ctx.context.impersonation))
		const webhook = webhooks.find((wh) => wh.id === ctx.params.webhookId)
		if (!webhook) {
			throw redirect({ to: '/smp/webhooks/{-$webhookId}', params: { webhookId: undefined } })
		}

		return { webhook }
	},
	component: RouteComponent,
})
